import React from "react";
import { useClientTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";

export const ClientCompanyTypeSelect = (props) => {
    const query=useClientTypeQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:
    <GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}
